import { useEffect, useState } from 'react';
import { DashboardService } from '../../services/dashboard.service';

/** kpiKey → targetValue for the institution, empty until loaded or on any fetch error. */
export default function useKpiTargets(institutionId: string): Record<string, number> {
    const [targets, setTargets] = useState<Record<string, number>>({});
    useEffect(() => {
        let live = true;
        // Reset on institution change: without this a failed refetch would keep the previous
        // tenant's targets painted on the new tenant's tiles.
        setTargets({});
        DashboardService.getKpiTargets(institutionId)
            .then(d => {
                if (!live) return;
                setTargets(Object.fromEntries(d.targets.map(t => [t.kpiKey, t.targetValue])));
            })
            .catch(() => {});
        return () => { live = false; };
    }, [institutionId]);
    return targets;
}
